import { render, staticRenderFns } from "./BmProspectosDetalle.vue?vue&type=template&id=a84e83b0&"
import script from "./BmProspectosDetalle.vue?vue&type=script&lang=js&"
export * from "./BmProspectosDetalle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports